import React from 'react';
import { TabBar } from "antd-mobile";
import { BrowserRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { fetchUserMobileAuthInfo,fetchCurrentUser } from '../actions/user-actions.js';
import 'antd-mobile/dist/antd-mobile.css';
import "./mobile.css";
const mapStateToProps = state => {
    return {
        user: state.user,
        routing: state.routing
    }
}

const mapDispatchToProps = { fetchUserMobileAuthInfo,fetchCurrentUser };
export default (WrapperComponent) => {
	class BasiceWrapper extends React.Component {

	  componentWillMount () {

				const tokenString = this.props.location.search;
				if (tokenString) {
					const tokenArray = tokenString.substr(1).split("=");
					if (2 === tokenArray.length && "token" === tokenArray[0]) {
						sessionStorage.setItem('token', tokenArray[1]);
					}
				}

        this.props.fetchUserMobileAuthInfo();
        this.props.fetchCurrentUser(true)
      }

	  render() {
	  	const { mobileUserInfo } = this.props.user
	  	const {pathname} =this.props.location
	    return (
	    	<BrowserRouter>
	      <div style={{display: "flex", flexDirection: "column", height: "100%"}}>
	      	<div style={{height: "100%", backgroundColor: "#f0f0f0", padding: "10px", overflowY: "auto"}}>
	      		<WrapperComponent fatherProps={this.props} />
	      	</div>
	      	<div style={{flex: 1,backgroundColor: "#fcfcfc"}}>
	      		{mobileUserInfo&&mobileUserInfo.Menus.length !== 0 &&
				<TabBar>
				{mobileUserInfo.Menus.map(v=>(
					<TabBar.Item
						key={v.path}
						title={v.name}
						icon={{uri:require(`./img/${v.icon}.svg`)}}
						selectedIcon={{uri:require(`./img/${v.icon}A.svg`)}}
						selected={pathname === v.path}
						onPress={()=>{
							this.props.history.push(v.path)
						}}
					>
						
					</TabBar.Item>
					))}
			</TabBar>}

		        {/*<TabBar
		          unselectedTintColor="#949494"
		          tintColor="#33A3F4"
		          barTintColor="white" 
		          >
				  	<TabBar.Item
		            icon={{ uri: require('./img/home.svg') }}
		            selectedIcon={{ uri: require('./img/homeA.svg') }}
		            title="首页"
		            key="首页"
		            selected={this.props.location.pathname === "/mobile/home"}
		            onPress={() => this.props.history.push("/mobile/home")} >
		          </TabBar.Item>
				 
		          <TabBar.Item
		            icon={{ uri: require('./img/home.svg') }}
		            selectedIcon={{ uri: require('./img/homeA.svg') }}
		            title="首页"
		            key="首页"
		            selected={this.props.location.pathname === "/mobile/home"}
		            onPress={() => this.props.history.push("/mobile/home")} >
		          </TabBar.Item>
		          <TabBar.Item
		            icon={{ uri: require('./img/application.svg') }}
		            selectedIcon={{ uri: require('./img/applicationA.svg') }}
		            title="申请"
		            key="申请"
		            selected={this.props.location.pathname === "/mobile/mobile-application-center"}
		            onPress={() => this.props.history.push("/mobile/mobile-application-center")} >
		          </TabBar.Item>
		          <TabBar.Item
		            icon={{ uri: require('./img/approval.svg') }}
		            selectedIcon={{ uri: require('./img/approvalA.svg') }}
		            title="审批"
		            key="审批"
		            selected={this.props.location.pathname === "/mobile/mobile-approval-center"}
		            onPress={() => this.props.history.push("/mobile/mobile-approval-center")} >
		          </TabBar.Item>
		          <TabBar.Item
		            icon={{ uri: require('./img/app.svg') }}
		            selectedIcon={{ uri: require('./img/appA.svg') }}
		            title="应用"
		            key="应用"
		            selected={this.props.location.pathname === "/mobile/mobile-app-center"}
		            onPress={() => this.props.history.push("/mobile/mobile-app-center")} >
		          </TabBar.Item>
		        </TabBar>*/}
	        </div>
	      </div>
	      </BrowserRouter>
	    );
	  }
	}
	BasiceWrapper = connect(mapStateToProps, mapDispatchToProps)(BasiceWrapper)
	return BasiceWrapper;
}



// WEBPACK FOOTER //
// ./src/layouts/MobileWrapper.js